import HistoryStatus from "@/enum/HistoryStatus";

export function historyStatus(status) {
    switch (status) {
        case HistoryStatus.PROCESSED:
            return { text: "Processado", color: "green" };
        case HistoryStatus.PROCESSED_MANUAL:
            return { text: "Processado manual", color: "teal" };
        case HistoryStatus.PROCESSED_MANUAL_ERROR:
            return { text: "Erro manual", color: "red darken-2" };
        case HistoryStatus.NEED_PROCESS:
            return { text: "Pendente", color: "amber darken-3" };
        default:
            return { text: status || "-", color: "grey" };
    }
}
